var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66.45 50.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.08,43.66c-.61,0-1.13-.44-1.25-1.04l-.95-5.15c-.06-.31,0-.62.17-.89L58.2.33c.11-.19.31-.31.53-.33.01,0,.03,0,.04,0,.19,0,.31.04.41.1l6.94,4.24c.33.2.44.64.24.98l-21.97,36.11c-.16.26-.41.46-.7.55l-5.22,1.63c-.12.04-.25.06-.38.06h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.88,50.79c-1.61,0-3.25-.06-4.9-.19-1.18-.09-2.07-1.13-1.98-2.31.08-1.11,1.05-1.99,2.2-1.99h.11c1.51.12,3.04.17,4.54.17,2.57,0,4.97-.17,7.11-.5l.23-.04-.19-.13c-3.82-2.68-5.82-6.73-5.36-10.83.64-5.66,5.56-9.94,11.45-9.94h.24c4.9.17,8.86,2.86,10.33,7.03,1.57,4.44-.06,9.53-4.25,13.27l-.15.14.2.02c4.85.59,12.3.89,22.16.89,4.14,0,8.78-.05,13.79-.16,1.22.05,2.17.96,2.19,2.1.01.57-.2,1.12-.6,1.53s-.93.65-1.51.66c-4.98.11-9.61.16-13.76.16-12.39,0-21.12-.47-25.94-1.4-.81-.16-1.57-.33-2.28-.53-3.74,1.34-8.31,2.03-13.65,2.03ZM19.92,29.34c-4.1,0-6.67,3.16-7,6.13-.42,3.73,2.33,6.99,7.36,8.73,1.24-.54,2.26-1.18,3.09-1.9,3-2.58,4.24-5.95,3.24-8.79-.88-2.5-3.28-4.06-6.42-4.16-.09,0-.18,0-.27,0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLog);
export default __webpack_public_path__ + "static/media/log.654b4a2b018fc32f75eb7d1870de719a.svg";
export { ForwardRef as ReactComponent };